import(/* webpackMode: "eager", webpackExports: ["BlockRenderer"] */ "/app/core/components/Builder/BlockRenderer.tsx");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
